let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b4gKm")).then(() => parcelRequire('ke7g0'));